/* eslint-disable */
// OriginalsCard — Originals/Items grid tile in New DNA (Card B: spotlight image
// stage + brand title + divided SHAPE/GENDER footer bar + ↩ dev chip). Extracted
// from the legacy CatalogView grid block. All data bindings preserved verbatim:
// title=brand, shape=shape1||shape, gender, dev count via useLinkedDevsMap (prop).
import React from "react";
import { SmartImg, computeContentCenter } from "../../utils";
import styles from "./OriginalsCard.module.css";
import AnnounceButton from "../system/AnnounceButton";

function GlassesPlaceholder() {
  return (
    <div className={styles.ph}>
      <svg width="44" height="44" viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="2.2">
        <rect x="4" y="8" width="32" height="18" rx="9" /><circle cx="14" cy="17" r="5" strokeWidth="2" />
        <circle cx="26" cy="17" r="5" strokeWidth="2" /><path d="M2 17h4M34 17h4" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
}

export default function OriginalsCard({
  item, isSelected, isFav, linkedCount = 0, priority = false, hoverPreviewEnabled = true,
  onOpen, onToggleSelect, onToggleFav, onHoverPreview, onHoverPreviewEnd,
}) {
  const imgs = (item.images || []).length > 0 ? item.images : (item.image ? [item.image] : []);
  const shapeVal = item.shape1 || item.shape || "";
  const gender = item.gender || "";

  return (
    <div
      className={`${styles.cardRoot} ${isSelected ? styles.selected : ""}`}
      onClick={onOpen}
      onMouseEnter={(e) => {
        if (hoverPreviewEnabled && onHoverPreview) {
          const r = e.currentTarget.getBoundingClientRect();
          onHoverPreview({ item, x: r.left + r.width / 2, y: r.top });
        }
      }}
      onMouseLeave={() => onHoverPreviewEnd && onHoverPreviewEnd()}
    >
      <div className={styles.stage}>
        {imgs.length > 0
          ? <SmartImg src={imgs[0]} displayWidth={300} alt={item.brand || ""} priority={priority}
              className={styles.stageImg} onLoad={(e) => computeContentCenter(e.target, imgs[0])} />
          : <GlassesPlaceholder />}
        <span className={styles.floor} aria-hidden="true" />

        <div className={`${styles.ctl} ${styles.ctlBox} ${isSelected ? styles.vis : ""}`}
          onClick={(e) => { e.stopPropagation(); onToggleSelect && onToggleSelect(); }}>
          <div className={`${styles.box} ${isSelected ? styles.on : ""}`}>{isSelected && <span className={styles.boxTick}>✓</span>}</div>
        </div>

        <div className={`${styles.ctl} ${styles.ctlFav} ${isFav ? `${styles.vis} ${styles.on}` : ""}`}
          onClick={(e) => { e.stopPropagation(); onToggleFav && onToggleFav(); }}>
          <svg width="15" height="15" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </div>

        {/* P7 — announce this original. A THIRD corner control (option 1):
            adds without moving the checkbox, the star or the pics badge. */}
        <AnnounceButton
          portal="catalog" className={`${styles.ctl} ${styles.ctlAnnounce}`} size={15}
          dataTest={`item-announce-${item.id}`}
          makeSeed={() => ({
            kind: 'item', id: String(item.id),
            code: item.sku || '', name: item.brand || '', image: imgs[0] || null,
          })}
        />

        {imgs.length > 1 && <span className={styles.pics}>{imgs.length} pics</span>}
      </div>

      <div className={styles.body}>
        {linkedCount > 0 && <span className={styles.devChip}>↩ {linkedCount} dev{linkedCount === 1 ? "" : "s"}</span>}
        <div className={styles.title}>{item.brand || "—"}</div>
        <div className={styles.footer}>
          <div className={styles.cell}>
            <div className={styles.microLabel}>Shape</div>
            <div className={`${styles.cellVal} ${shapeVal ? "" : styles.empty}`}>{shapeVal || "—"}</div>
          </div>
          <div className={styles.cell}>
            <div className={styles.microLabel}>Gender</div>
            <div className={`${styles.cellVal} ${gender ? "" : styles.empty}`}>{gender || "—"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
